module.exports = __webpack_public_path__ + "img/hmtt.c784db9e.png";